import React from "react";
import ContentModerationView from "@/components/contentModeration/ContentModerationView";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > FeedPosts: basic details of one item with Deactivate / Reactivate / Delete.
 */
const FeedPostsModerationView = () => (
  <ContentModerationView sectionKey="feedPosts" />
);

FeedPostsModerationView.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.feedPosts.list,
    pathname: contentModeration.feedPosts.list,
    active: false,
  },
  {
    name: breadcrumb_key.contentModeration.feedPosts.view,
    pathname: "",
    active: true,
  },
];

export default FeedPostsModerationView;
